import { IParsedWhitelabelWithRelations } from '@/Interfaces/Whitelabels/Whitelabel.interface';
import { useFormContext } from 'react-hook-form';
import OrganizationSelect from '../OrganizationSelect';
import AdditionalControlsInputLabel from './AdditionalControlsInputLabel';

interface IProps {
  whitelabels: IParsedWhitelabelWithRelations[];
  organizations: IParsedWhitelabelWithRelations[];
  shouldUnregister?: boolean;
  showOrgControl?: boolean;
  whitelabelDisabled?: boolean;
}

const AdditionalWhitelabelAdminControls = ({
  whitelabels,
  organizations,
  shouldUnregister,
  showOrgControl,
  whitelabelDisabled,
}: IProps) => {
  const { control } = useFormContext();

  return (
    <>
      <hr className='-mx-[32px] mt-8 mb-4' />
      {showOrgControl ? (
        <div className='mb-3'>
          <AdditionalControlsInputLabel htmlFor='org-select' id='org-select-label'>
            Select Organization
          </AdditionalControlsInputLabel>
          <OrganizationSelect
            control={control}
            options={organizations}
            shouldUnregister={shouldUnregister}
            id='org-select'
            name='organization'
            placeholder='Select Organization'
          />
        </div>
      ) : null}
      <div className='mb-3'>
        <AdditionalControlsInputLabel id='whitelabel-select-label' htmlFor='whitelabel-select'>
          Select Whitelabel
        </AdditionalControlsInputLabel>
        <OrganizationSelect
          control={control}
          options={whitelabels}
          shouldUnregister={shouldUnregister}
          disabled={whitelabelDisabled}
          id='whitelabel-select'
          name='whitelabel'
          placeholder='Select Whitelabel'
        />
      </div>
    </>
  );
};

export default AdditionalWhitelabelAdminControls;
